import React from "react";

import Time from "./Time";


import CountUp from 'react-countup';

const UpcomingCard = () => {
    const cardItem = [1, 2, 3, 4];
    return (
        <>
            {
                cardItem.map((item, id) =>
                    <div key={id} className="col-xl-3 col-lg-3 col-md-12 col-sm-12">
                        <div className="_upc_sec_card">
                            <div className="_upc_sec_card_inner">
                                <a href="auction" className="_upc_sec_card_top">
                                    <img src={`assets/img/sp${item}.png`} alt="allblocks" className="_upc_sec_card_top_img" />
                                </a>
                                <div className="_upc_sec_card_btm">
                                    <div className="_upc_card_btm_prfl">
                                        <div className="_upc_card_btm_prfl_img_wrap">
                                            <img src="assets/img/spprfl1.png" alt="allblocks" className="_upc_card_btm_prfl_img" />
                                            <img src="assets/img/spprfl2.png" alt="allblocks" className="_upc_card_btm_prfl_img" />
                                        </div>
                                        <div className="_upc_card_btm_like">
                                            <span className="_upc_card_btm_like_main"><svg xmlns="http://www.w3.org/2000/svg" width={20} height={18} fill="none" viewBox="0 0 20 18">
                                                <path stroke="#808191" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.728" d="M10.707 16.482a1.884 1.884 0 0 1-1.071 0c-2.506-.856-8.105-4.424-8.105-10.473 0-2.67 2.152-4.83 4.804-4.83 1.573 0 2.964.76 3.837 1.936a4.778 4.778 0 0 1 3.836-1.936c2.653 0 4.804 2.16 4.804 4.83 0 6.049-5.599 9.617-8.105 10.473Z" />
                                            </svg>
                                            </span>
                                            <p className="_upc_card_btm_like_num"><CountUp duration={10} deplay={0} end={323} /></p>
                                        </div>
                                    </div>
                                    <h4 className="_upc_card_btm_title">6.50$</h4>
                                    <div className="_upc_card_btm_time_wrap">
                                        <p className="_upc_card_btm_time_title">Highest Bid Auction</p>
                                        <h3 className="_upc_card_btm_time"> 
                                        <Time />
                                        
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        </>
    )
}

export default UpcomingCard;